<template>
  <div class="nettdoc-save-and-export" :style="pdfIsLoading || pictureIsLoading ? 'cursor:wait' : 'cursor:initial'">
    <div class="nettdoc-save-and-export__bottom">
      
      <template v-if="exportActive">
        <h2 class="nettdoc-header">{{ $t('Save and export') }}</h2>
        <p class="nettdoc-save-and-export__bottom--text">
          {{ $t('Save and export the anamnese sheets on your own device. The cache will be deleted completely after you close the site.')}}
        </p>

        <div class="nettdoc-save-and-export__image-row">
          <div class="nettdoc-save-and-export__image-row--image">
            <img src="../assets/icon-button-ic-pic.svg" alt="save" />
            <span @click="saveAsPicture" :style="pdfIsLoading || pictureIsLoading ? 'cursor:wait' : 'cursor:pointer'">{{$t('save as a picture')}}</span>
          </div>
          <template v-if="pictureError !== ''">
            <span style="color:var(--dark-peach)">{{$t('Something went wrong while creating the Picture.')}}</span>
            <span style="color:var(--dark-peach)">{{pictureError}}</span>
          </template>
          <div class="nettdoc-save-and-export__image-row--image">
            <img src="../assets/icon-button-ic-pdf.svg" alt="pdf" />
            <span @click="saveAsPdf" :style="pdfIsLoading || pictureIsLoading ? 'cursor:wait' : 'cursor:pointer'">{{$t('generate PDF file')}}</span>
          </div>
          <template v-if="pdfError !== ''">
            <span style="color:var(--dark-peach)">{{$t('Something went wrong while creating the PDF.')}}</span>
            <span style="color:var(--dark-peach)">{{pdfError}}</span>
          </template>
        </div>

        <div class="nettdoc-save-and-export__bottom--cancel">
          <div>
            <p></p>
            <p><span @click="exportActive = false">{{$t('Cancel')}}</span></p>
          </div>
        </div>
      </template>

      <template v-else>
        <h2 class="nettdoc-header">{{ $t('Heading') }}</h2>
        <NumberInput
          :textInput="true"
          label="Heading*"
          :showLabel="true"
          :model="heading"
          v-on:action="value => setHeading(value)"
        /> 
        <p class="nettdoc-save-and-export__bottom--text" style="color: var(--dark-peach)">
          {{ $t(headingError) }}
        </p>
        <p class="nettdoc-save-and-export__bottom--text">
          {{ $t('Give a heading for this document, so that you can find it easily for a later time in your device.') }}
        </p>
        <div class="nettdoc-save-and-export__bottom--cancel" style="text-align: unset">
          <div>
            <p><span @click="$router.push(`/${$i18n.locale}/nettdoctor/summary`)">{{$t('Cancel')}}</span></p>
            <p><span @click="headingComplete ? exportActive = true : ''" style="float:right;text-align:right;" :style="!headingComplete ? 'opacity:0.5' : ''">{{$t('Save and Export')}}</span></p>
          </div>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import { observer } from "mobx-vue";
import store from "../store/store";
import NumberInput from '../components/NumberInput'
import axios from 'axios'
export default observer({
  name: 'SaveAndExport',
  data() {
    return {
      heading: '',
      headingError: '',
      exportActive: false,
      pictureError: '',
      pdfError: '',
      pictureIsLoading: false,
      pdfIsLoading: false,
      store: store
    }
  },
  components: {
    NumberInput
  },
  computed: {
    headingComplete: function() {
      return this.heading && this.heading !== '' && this.headingError === ''
    }
  },
  methods: {
    setHeading: function(heading) {
      if (heading) {
        const regex = /^[0-9a-zA-Z. ]*$/
        if (!heading.match(regex)) {
          this.heading = heading
          this.headingError = "Heading should only contain letters and numbers."
        } else {
          this.heading = heading
          this.headingError = ''
        }
      } else {
          this.heading = heading
          this.headingError = ''
      }
    },
    isJson: function(value) {
      return (/^[\],:{}\s]*$/.test(value.replace(/\\["\\/bfnrtu]/g, '@').
          replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/g, ']').
          replace(/(?:^|:|,)(?:\s*\[)+/g, '')))
    },
    createJsonStorage: function(storage) {
      let storageAsJson = {}
      for ( const key in storage ) {
        const value = storage[key]
        if (this.isJson(value)) {
          storageAsJson[key] = JSON.parse(value)
        } else {
          storageAsJson[key] = value
        }
      }
      return storageAsJson
    },
    saveAsPicture: function() {
      this.pictureIsLoading = true
      let storage = {}
      const filename = this.heading ? this.heading.replace(/\s/g, '') : ''
      storage.filename = filename
      storage.url = location.origin+'/'+this.$i18n.locale+'/nettdoctor/print'
      storage.localstorage = this.createJsonStorage({...localStorage})

      const restUrl = location.protocol+'//pdfservice.'+location.hostname+'/create-png'
      //const restUrl = location.protocol+'//'+location.hostname+':8081/create-png'

      axios.post(restUrl, storage, { responseType: 'arraybuffer'})
        .then( res => {
          this.pictureError = ''
          let blob = new Blob([res.data], {type: 'image/png'});
          // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
          if (navigator.msSaveOrOpenBlob){
              return navigator.msSaveOrOpenBlob(blob, filename);
          }
          // create a link element, hide it, direct it towards the blob, and then 'click' it programatically
          let a = document.createElement("a");
          a.style.display= "none";
          document.body.appendChild(a);
          // create a DOMString representing the blob and point the link element towards it
          let url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = filename+'.png';
          // programatically click the link to trigger the download
          a.click();
          // release the reference to the file by revoking the Object URL
          // wait for the next dom layout
          window.requestAnimationFrame(()=>{
              // schedule directly after the layout event.
              setTimeout(()=>{
                  a.parentNode.removeChild(a);
              },0);
          });
          this.pictureIsLoading = false
        })
        .catch( err => {
          this.pictureError = err
          this.pictureIsLoading = false
        })
    },
    saveAsPdf: function() {
      this.pdfIsLoading = true
      let storage = {}
      const filename = this.heading ? this.heading.replace(/\s/g, '') : ''
      storage.filename = filename
      storage.url = location.origin+'/'+this.$i18n.locale+'/nettdoctor/print'
      storage.localstorage = this.createJsonStorage({...localStorage})

      const restUrl = location.protocol+'//pdfservice.'+location.hostname+'/create-pdf'
      //const restUrl = location.protocol+'//'+location.hostname+':8081/create-pdf'


      axios.post(restUrl, storage, {responseType: 'arraybuffer'})
        .then( res => {
          this.pdfError = ''
          let blob = new Blob([res.data], {type: 'application/pdf'});
          // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
          if (navigator.msSaveOrOpenBlob){
              return navigator.msSaveOrOpenBlob(blob, filename);
          }
          // create a link element, hide it, direct it towards the blob, and then 'click' it programatically
          let a = document.createElement("a");
          //a.setAttribute('target', '_blank');
          a.style.display= "none";
          document.body.appendChild(a);
          // create a DOMString representing the blob and point the link element towards it
          let url = URL.createObjectURL(blob);
          a.href = url;
          a.download = filename;
          // programatically click the link to trigger the download
          a.click();
          // release the reference to the file by revoking the Object URL
          // wait for the next dom layout
          window.requestAnimationFrame(()=>{
              // schedule directly after the layout event.
              setTimeout(()=>{
                  a.parentNode.removeChild(a);
              },0);
          });
          this.pdfIsLoading = false
        })
        .catch( err => {
          this.pdfError = err
          this.pdfIsLoading = false
        })
    }
  }
})
</script>

<style lang="scss" scoped>
.nettdoc-save-and-export {
  #test {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
  }
  overflow: hidden;
  position: relative;
  height: calc(100vh - 155px);
  width: 100%;
  background-color: grey;
  &__bottom {
    padding-top: 36px;
    box-sizing: border-box;
    width: 100%;
    background-color: var(--white);
    border-radius: 10px;
    position: absolute;
    bottom: -10px;
    height: calc(90%);
    min-height: 300px;
    h2 {
      font-size: 26px;
      font-weight: 500;
    }
    &--text {
      padding: 0 16px;
    }
    &--cancel {
      box-sizing: border-box;
      border-top: 1px solid #d8d8d8;
      padding: 4px 20px 9px 22px;
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: right;
      & div {
        text-transform: uppercase;
        font-weight: 700;
        margin: unset;
        display: grid;
        grid-template-columns: auto auto;
        grid-column-gap: 16px;
        & p {
          align-self: center;
          & span {
            cursor: pointer;
          }
        }
      }
    }
  }
  &__image-row {
    display: grid;
    grid-template-rows: auto auto auto;
    padding: 0 16px;
    &--image {
      margin: 20px 0;
      display: grid;
      grid-template-columns: max-content max-content auto;
      grid-column-gap: 24px;
      img {
        height: 24px;
        width: 24px;
        align-self: center;
        justify-self: center;
      }
      p {
        margin: unset;
        text-align: left;
        line-height: 30px;
      }
      span {
        text-align: left;
        font-size: 16px;
        text-transform: uppercase;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
}
.nettdoc-button {
        text-decoration: none;
        min-width: 110px;
        margin: unset;
        position: relative;
        text-transform: uppercase;
        opacity: 0.2;
        border-radius: 4px;
        background-color: var(--marigold);
        font-size: 12px;
        font-weight: 800;
        padding-top: 4px;
        text-align: center;
        color: var(--white);
        cursor: default;
        span {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }
    .nettdoc-active {
        opacity: 1;
        cursor: pointer;
        &:hover, &:active, &:focus {
            background-color: var(--charcoal-grey);
        }
    }
</style>